/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import {
  SITUATION_COHABITATION,
  SITUATION_MARRIED,
  SITUATION_SINGLE
} from '../../enums/FamilySituationCodes.mjs'

export type FamilySituationLabelProps = {
  value: FamilySituation
}

function FamilySituationLabel (props: FamilySituationLabelProps) {
  const { value } = props
  const intl = useIntl()

  if (value === SITUATION_MARRIED) {
    return intl.formatMessage({
      id: 'married',
      defaultMessage: 'Marié(e)'
    })
  }
  if (value === SITUATION_SINGLE) {
    return intl.formatMessage({
      id: 'bachelor',
      defaultMessage: 'Célibataire'
    })
  }
  if (value === SITUATION_COHABITATION) {
    return intl.formatMessage({
      id: 'cohabitation',
      defaultMessage: 'Concubinage'
    })
  }
  return null
}

export default FamilySituationLabel
